export const CREDIT_ENTRY_METHOD = {
	SWIPE: 0,
	HPP: 1,
	PASS: 2,
	DEVICE: 3,
	EMV_DIP: 4,
	EMV_NFC: 5,
	APPLE_PAY: 6,
	GOOGLE_PAY: 7,
} as const;
type TTemp = keyof typeof CREDIT_ENTRY_METHOD;
export type TCreditEntryMethod = typeof CREDIT_ENTRY_METHOD[TTemp];
